export function findTagIdByName(name, tags) {
    const tagFound = tags.find((tag) => tag.slug === name);
    return tagFound?.id;
}

export function mapFiltersToTags(filters, tags) {
    return filters.map((filterGroup) => {
        return {
            ...filterGroup,
            items: filterGroup.items.map((filter) => {
                return { ...filter, id: findTagIdByName(filter.tag, tags) };
            }),
        };
    });
}
